import {
  SIMPLE_CHAT_ADD_MESSAGE,
  SIMPLE_CHAT_RESET
} from "../constants/action-types";

export function addSimpleChatMessage(
  userResponse: string = "",
  aiResponse: string = "",
  isLiked: boolean = false,
  isDisliked: boolean = false,
  uniqueId: string = Math.random().toString(36).substring(7)
) {
  return {
    type: SIMPLE_CHAT_ADD_MESSAGE,
    userResponse,
    aiResponse,
    isLiked,
    isDisliked,
    uniqueId,
  };
}

export function resetSimpleChat() {
  return {
    type: SIMPLE_CHAT_RESET
  };
} 